import TaskName from './TaskName';
import WorkTemplateTaskControls from './WorkTemplateTaskControls';

import classes from './taskHeader.module.css';

const WorkTemplateTaskHeader = () => {
  return (
    <div className={classes.taskHeaderContainer}>
      <TaskName />
      <div className={classes.actionButtonsContainer}>
        <WorkTemplateTaskControls />
      </div>
    </div>
  );
};

export default WorkTemplateTaskHeader;
